import _ from "lodash";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import Loading from "UIComponents/Loading";
import { resetPasswordDetails } from "Administrator/modules/CommonModule";
import { isUserAccountExists, updateUserInfo } from "Login/modules/LoginModule";
import { updateUser } from "AppComponents/CollaboratorV2/modules/Modules";

import classes from "./VisitorSignUp.scss";
import SnpVisitorSignup from "./components/SnpVisitorSignup";
import CasVisitorSignup from "./components/CasVisitorSignup";

const VisitorSignUp = props => {
  const {
    updateInputField,
    setVisitorLoginForm,
    checkEmailVerification,
    data,
    customStyle: { headerStyle, subTextStyle },
    renderTradeMarkText,
    updateCurrentScreen,
    updateUserInfo,
  } = props;

  const onVisitorLoginLink = () => {
    updateCurrentScreen({
      type: "visitorLogin",
      userType: "staff",
      role: "visitor",
      paramsToBeRemoved: [
        "first_name",
        "last_name",
        "id",
        "email",
        "token",
        "screen",
        "user_id",
      ],
    });
  };

  useEffect(() => {
    const getUserAccountStatus = async () => {
      if (!_.isEmpty(data)) {
        const email = data.email;
        const { stateCode = "" } = await isUserAccountExists({
          email,
          region: data.region,
        });
        if (
          stateCode === "MULTIPLE_IDENTITY_PWD_UPDATED" ||
          stateCode === "SINGLE_IDENTITY_PWD_UPDATED"
        ) {
          setVisitorLoginForm("loginForm", { email });
          onVisitorLoginLink();
        } else {
          setIsLoading(false);
        }
      }
    };
    getUserAccountStatus();
  }, [data]);

  const [isLoading, setIsLoading] = useState(true);

  const handleSignIn = () => {
    const { password } = data;
    const errorCount = +_.isEmpty(password);
    const { showErrorToast, sendResetPassword } = props;
    showErrorToast({ errorCount });
    if (errorCount > 0) return;
    sendResetPassword();
  };

  const handleCasExternalSignIn = async () => {
    const {
      id,
      email,
      password,
      firstName,
      lastName,
      visitorsOrganizationName: organizationName,
      contact,
      token,
    } = data;
    const { updateUser } = props;

    const errorCount =
      _.isEmpty(password) +
      _.isEmpty(firstName) +
      _.isEmpty(lastName) +
      _.isEmpty(organizationName);
    const { showErrorToast, sendResetPassword } = props;
    showErrorToast({ errorCount });

    if (errorCount > 0) return;
    /*******************************************************************************************************
     * Setting token, as it is passed in request headers while executing mutation(passed by middleware in apolloclient.js)
     ********************************************************************************************************/
    updateUserInfo({ token });
    await sendResetPassword();

    updateUser({
      userInfo: {
        id,
        email,
        firstName,
        lastName,
        organization: organizationName,
        contact,
      },
      shouldUpdateCache: false,
    });
  };

  const renderSignupFormElement = () => {
    switch (_.get(data, "moduleName", "")) {
      case "CAS":
        return (
          <CasVisitorSignup
            headerStyle={headerStyle}
            subTextStyle={subTextStyle}
            data={data}
            updateInputField={updateInputField}
            checkEmailVerification={checkEmailVerification}
            onVisitorLoginLink={onVisitorLoginLink}
            handleSignIn={handleCasExternalSignIn}
            renderTradeMarkText={renderTradeMarkText}
          />
        );

      default:
        return (
          <SnpVisitorSignup
            headerStyle={headerStyle}
            subTextStyle={subTextStyle}
            data={data}
            updateInputField={updateInputField}
            checkEmailVerification={checkEmailVerification}
            onVisitorLoginLink={onVisitorLoginLink}
            handleSignIn={handleSignIn}
            renderTradeMarkText={renderTradeMarkText}
          />
        );
    }
  };

  const loaderElement = (
    <div className={classes.loaderContainer}>
      <Loading />
    </div>
  );

  return isLoading ? loaderElement : renderSignupFormElement();
};

const mapActionCreators = {
  resetPasswordDetails,
  updateUser,
  updateUserInfo,
};

export default connect(null, mapActionCreators)(VisitorSignUp);
